export const API_SINGLE_TAG = '/tag/:tagId'
export const API_SINGLE_TAGSCAN = '/tag/tag-scan/:tagScanId'

export const makeSingleTagRequestRoute = (tagId) => API_SINGLE_TAG.replace(':tagId', tagId)

export const makeSingleTagScanRequestRoute = (tagScanId) =>
  API_SINGLE_TAGSCAN.replace(':tagScanId', tagScanId)
